import { filterUndefined } from '../../../../utils/FilterUndefinedObject';
import './RejectedAnswer.scss';

/**
 * Sub-component for displaying Reject answer animation
 */
const defaultProps = {
  noBorder: false,
};
export default function RejectedAnswer(props) {
  const { noBorder } = { ...defaultProps, ...filterUndefined(props) };
  return (
    <div className={`rejected-answer ${noBorder ? '' : 'rejected-answer-border'}`}>
      <div className='rejected-answer-icon'>
        X
      </div>
    </div>
  );
}
